import { ListViewImplementation } from '@commoncore/implementation/ListViewImplementation';
import { CustomSortService } from '@commoncore/services/custom-sort.service';
import { MultiSelectLibrary } from '@commoncore/utils/MultiSelectUtil';
import { AppEvents } from '@commoncore/utils/app-events';
import { ENV_CONFIG } from '@env-properties/environment-config';



export class FavoritesImplementation {
  public router: any;
  public http: any;
  public route: any;
  public universalService: any;
  public multiSelect: any;
  public doubleClicked: boolean = false;
  public listService: any;
  public enableButton:boolean = false;
  public folderName: string="";
  public AlbumName:string = "";
  contextMenuService: any;
  customMetadata: any;
  public sortType = "%2DfavouritedDate";
  public sortByDateArray = [];
  customSort:any;
  listImpl:any;
  loggerService: any;
  localStorageSvc:any;
  static singleInstance:any = null;
  globalService: any;
  currentTab = "";
  favNextLink: any="";
  favPreviousLink : any = "";
  public currentPageNo = 0;
  public previousPageNo = -1;
  paginationService: any;
  favouriteslistsize = 0;
  public resizeableObjectList = []; // it is used only for resize window frame - do not overwrite or use.
    



  constructor(globalService) {
    this.universalService = globalService.getUniversalServiceRef();
    this.globalService = globalService;
  }

  public static getInstance(globalService):FavoritesImplementation{
    if(this.singleInstance == null){
        this.singleInstance = new FavoritesImplementation(globalService);
    }
    return this.singleInstance;
}

  public setHandler(globalService) {
    this.router = globalService.getRouterRef();
    this.http = globalService.getHttpClientRef();
    this.universalService = globalService.getUniversalServiceRef();
    this.contextMenuService = globalService.getContextMenuServiceRef();
    this.route = globalService.getActivatedRoute();
    this.loggerService = globalService.getLoggerServiceRef();
    this.multiSelect = MultiSelectLibrary.getInstance(globalService);
    this.listService = globalService.getListServiceRef();
    this.listImpl = ListViewImplementation.getInstance(globalService)
    this.customMetadata = globalService.getCustomMetadataServiceRef();
    this.customSort = new CustomSortService(this.universalService);
    this.localStorageSvc = globalService.getLocalStorageSvcRef();
    this.paginationService = globalService.getPaginationServiceRef();
  }

  

    fetchFavorites(url,tab){
        this.universalService.showLoader = true;
        this.universalService.shareViewTypeSetting();
        this.resetValuesBeforeFetchingData();
        if(tab == "My Files"){
            this.fetchMyFilesFavoritesApi(url);
        }else{
            this.fetchMyAlbumsFavorites(url)
        }
        
    }

    resetValuesBeforeFetchingData(){
      this.currentPageNo = 0;
      this.previousPageNo = -1;
      this.paginationService.LOCAL_DB = {};
      this.sortByDateArray = [];
      this.universalService.mobileSelectedObj = [];
      this.universalService.objectsPreviewArray = [];
      this.favouriteslistsize = 0;
      this.universalService.scrollToTopIcon = false;
      this.favNextLink = "";
      this.favPreviousLink = "";
    }

    fetchMyFilesFavoritesApi(url){
        var self = this;
        return new Promise(function(resolve,reject){
            self.http.get(url).subscribe(
                resp=>{
                    self.loggerService.log("favorites resp",resp);
                    self.paginationService.spliceAndSaveDataInLocalDB(resp["objects"]);
                    self.setNextAndPreviousLinks(resp);
                    let favoritedFilesList = self.paginationService.getBufferDataForNextPage(self.currentPageNo);
                    self.paginationService.deleteLocalBufferOnceThePageIsViewed(self.currentPageNo)
                    var favList = self.customMetadata.segregateData(favoritedFilesList,'allfiles');
                    favList = self.customSort.sortListViewFilesByAttribute(favList,"Descending","favoriteDate");
                    self.resizeableObjectList = favList;

                    if(favList.length == 0){
                        self.universalService.emptyFav = true;
                        self.universalService.showSortButtons = false;
                    }else{
                      self.universalService.showSortButtons = true;
                    }
                    if(!self.universalService.isMobileDevice && self.universalService.listView){
                        self.favouriteslistsize = self.favouriteslistsize + favList.length;
                        self.listImpl.decideListOptions('favorites');
                        self.listImpl.fetchFavoritesListView(favList);
                    }else{
                        self.sortByDates(favList);
                        self.bindMultiSelect();
                    }
                    
                },
                err=>{
                    self.universalService.showLoader = false;
                    self.loggerService.log("error in fetching favorites for my files",err)
                }
            )
        })
    }

    fetchMyAlbumsFavorites(url){
        var self = this;
        return new Promise(function(resolve,reject){
            self.http.get(url).subscribe(
                resp=>{
                    self.loggerService.log("favorites albums resp",resp);
                    resp["objects"] = resp["files"]?resp["files"]:[];
                    self.paginationService.spliceAndSaveDataInLocalDB(resp["objects"]);
                    self.setNextAndPreviousLinks(resp);
                    let favoritedFilesList = self.paginationService.getBufferDataForNextPage(self.currentPageNo);
                    self.paginationService.deleteLocalBufferOnceThePageIsViewed(self.currentPageNo)
                    resp = self.setOwnerDetails(favoritedFilesList);
                    var favList = self.customMetadata.segregateData(resp,'allfiles');
                    favList = self.customSort.sortListViewFilesByAttribute(favList,"Descending","favoriteDate")
                    self.resizeableObjectList = favList;
                    if(favList.length == 0){
                        self.universalService.emptyFav = true;
                        self.universalService.showSortButtons = false;
                    }else{
                      self.universalService.showSortButtons = true;
                    }
                    if(!self.universalService.isMobileDevice && self.universalService.listView){
                        self.favouriteslistsize = self.favouriteslistsize + favList.length;
                        self.listImpl.decideListOptions('favorites');
                        self.listImpl.fetchFavoritesListView(favList)
                    }else{
                        self.sortByDates(favList);
                        self.bindMultiSelect();
                    }
                    
                },
                err=>{
                    self.universalService.showLoader = false;
                    self.loggerService.log("error in fetching favorites for my albums",err)
                }
            )
        })
    }

    renderDataOnResize(favList) {
      this.favouriteslistsize = 0;
      if(!this.universalService.isMobileDevice && this.universalService.listView){
        this.listImpl.decideListOptions('favorites');
        this.favouriteslistsize = this.favouriteslistsize + favList.length;
        this.listImpl.fetchFavoritesListView(favList);
      } else{
        this.sortByDates(favList);
        this.bindMultiSelect();
      }
    }

    bindMultiSelect(){
        this.multiSelect = MultiSelectLibrary.getInstance(this.globalService);
        if(this.universalService.listView) {
            this.multiSelect.bindMultiSelectLibrary("#favoriteFilesWrapperId", "list_info", ".listItem:visible", false,this.universalService.virtualGridEnabled,false);
            this.multiSelect.bindMultiSelectUIevent(".main-wrapper", ".list_file_child");
          } else {
            setTimeout(() => {
              this.multiSelect.bindMultiSelectLibrary(".favoriteFilesWrapper", "grid_info", ".gridItem:visible", true,this.universalService.virtualGridEnabled,false);
              this.multiSelect.bindMultiSelectUIevent(".tab-content", ".grid_file_child");  
            }, 100);
          }
    }

    sortByDates(files){
        var array  = this.customSort.sortByDates(files,this.sortByDateArray,[],"modifiedDate")
        this.sortByDateArray = array[0];
        this.universalService.objectsPreviewArray = array[1];
        this.loggerService.log("sort by date array",this.sortByDateArray)
        setTimeout(() => {
            this.universalService.showLoader = false;  
        }, 10);
        AppEvents.virtualDOMObservable.next({"updateVDOM":true})
        AppEvents.multiSelectEvent.next({"dataArray":this.sortByDateArray})
    }


    setNextAndPreviousLinks(suc){
      if (suc["nextLink"]) {
        this.favNextLink = suc["nextLink"]
        if (this.favNextLink.includes("sort=")) {
          if (this.favNextLink.includes("sort=+")) {
            this.favNextLink=this.favNextLink.replace("sort=+", "sort=%2B")
          }else if (this.favNextLink.includes("sort=-")) {
            this.favNextLink=this.favNextLink.replace("sort=-", "sort=%2D")
          }
        }
      } else {
        this.favNextLink = ""
      }


      if(this.currentTab == "My Files"){
        let favoritesMyFilesEndpoint = ENV_CONFIG["commonUrls"]["nmsMetaData"] + ENV_CONFIG["commonUrls"]["favorites"];
        this.favNextLink = this.favNextLink.includes(favoritesMyFilesEndpoint) ? this.favNextLink : this.favNextLink.replace(ENV_CONFIG["commonUrls"]["nmsMetaData"],favoritesMyFilesEndpoint);
      }else if(this.currentTab == "Album Files"){
        let favoritesAlbumsEndpoint = ENV_CONFIG["commonUrls"]["albumsMetaData"] + ENV_CONFIG["commonUrls"]["favorites"];
        this.favNextLink = this.favNextLink.includes(favoritesAlbumsEndpoint) ? this.favNextLink : this.favNextLink.replace(ENV_CONFIG["commonUrls"]["albumsMetaData"],favoritesAlbumsEndpoint);
      }
    }

    selectAll(event){
        this.listImpl.selectAll(event)
    }



  setOwnerDetails(files){
    let self = this
    const userData = self.localStorageSvc.getUserData(true);
    //let userID = self.localStorageSvc.getUserId(true);
    let userID = userData["userId"];
    files.map(function(object){
      if(object["owner"]){
        if(object["owner"]["ownerUserId"] == userID){
          object["isLoggedInUsrFileOwner"] = true
        } else{
          object["isLoggedInUsrFileOwner"] = false
        }
        
        if(self.universalService.currentAlbum != undefined && userID == self.universalService.currentAlbum.owner.ownerUserId){
            object["isLoggedInUsrAlbumOwner"] = true
        } else{
            object["isLoggedInUsrAlbumOwner"] = false
        }
      }
    })
    return files;
  }

  async createUrlForNextLink(docheignt, toppos, url) {
    if (toppos == 0) {
      this.universalService.scrollToTopIcon = false;
    } else {
      this.universalService.scrollToTopIcon = true;
      let checkIfContaineris95PercScrolled = this.universalService.virtualGridEnabled ? true : (toppos + $(".scrollableContainer").innerHeight()) >= (0.95 * docheignt)
      
      if(checkIfContaineris95PercScrolled && this.previousPageNo != this.currentPageNo && this.paginationService.LOCAL_DB[this.currentPageNo + 1] && this.paginationService.LOCAL_DB[this.currentPageNo + 1].length != 0){
        this.previousPageNo = this.currentPageNo;
        setTimeout(async () => { // timeout is added to restrict fetching data for multiple pages back to back as the scroll event is fired multiple times
          this.currentPageNo ++;
          let objList = await this.paginationService.getBufferDataForNextPage(this.currentPageNo);
          await this.appendData(objList);
          this.paginationService.deleteLocalBufferOnceThePageIsViewed(this.currentPageNo)
        }, this.paginationService.bufferTimeoutForFetchingData);
      }
      if (checkIfContaineris95PercScrolled && this.favNextLink != "" && this.favPreviousLink != this.favNextLink) {
        this.favPreviousLink = this.favNextLink;
        this.universalService.showLoader = true;
        this.getNextPageData(url);
      }
    }
  }

  createUrlForNextLinkForListView(url) {
    if (this.listService.listOptions.api.getVerticalPixelRange().top == 0)
      this.universalService.scrollToTopIcon = false;
    else
      this.universalService.scrollToTopIcon = true;
    if(this.favouriteslistsize - this.listService.listOptions.api.getLastDisplayedRow() < 3 && this.previousPageNo != this.currentPageNo && this.paginationService.LOCAL_DB[this.currentPageNo + 1] && this.paginationService.LOCAL_DB[this.currentPageNo + 1].length != 0){
      this.previousPageNo = this.currentPageNo;
      setTimeout(async () => { // timeout is added to restrict fetching data for multiple pages back to back as the scroll event is fired multiple times
        this.currentPageNo ++;
        let objList = await this.paginationService.getBufferDataForNextPage(this.currentPageNo);
        await this.appendData(objList);
        this.paginationService.deleteLocalBufferOnceThePageIsViewed(this.currentPageNo)
      }, this.paginationService.bufferTimeoutForFetchingData);
    }

    if (this.favouriteslistsize - this.listService.listOptions.api.getLastDisplayedRow() < 3) {
      if ((this.favPreviousLink != this.favNextLink)) {
        this.favPreviousLink = this.favNextLink
        if (this.favNextLink != "") {
          this.universalService.showLoader = true;
          this.getNextPageData(url);
        }
      }
    }        
  }
  
  getNextPageData(url) {
    this.http.get(url).subscribe(
      async nextPageData => {
        let objectsList = nextPageData["objects"] ? nextPageData["objects"] : (nextPageData["files"] ? nextPageData["files"] : []);
        if(objectsList && !this.paginationService.LOCAL_DB[this.currentPageNo]){ // this condition is added when user has scrolled all the buffer data, there is no buffer data left and API call is taking time or due to network latency to return data, post API response we are populating the data
          let bufferDataPresent = this.paginationService.checkIfBufferDataIsPresent();
          if(!bufferDataPresent){
            this.currentPageNo = Object.keys(this.paginationService.LOCAL_DB).length;
            this.previousPageNo = this.currentPageNo - 1;
            this.paginationService.spliceAndSaveDataInLocalDB(objectsList);
            this.setNextAndPreviousLinks(nextPageData);
            let objList = await this.paginationService.getBufferDataForNextPage(this.currentPageNo);
            await this.appendData(objList);
            this.paginationService.deleteLocalBufferOnceThePageIsViewed(this.currentPageNo);
            return;
          }
        }
        this.universalService.showLoader = false;
        this.paginationService.spliceAndSaveDataInLocalDB(objectsList);
        this.setNextAndPreviousLinks(nextPageData);
      },
      err => {
        this.universalService.showErrorMessage(err);
      }
    )
  }

  async appendData(objectsList) {
    var self = this;
    if (objectsList != undefined && objectsList.length > 0 && this.universalService.emptyFav) {
      this.universalService.emptyFav = false;
    }
    var favouritesList = this.customMetadata.segregateData(objectsList, "allfiles");
    self.resizeableObjectList = self.resizeableObjectList.concat(favouritesList);
    
    if(this.universalService.listView && !this.universalService.isMobileDevice){
      this.favouriteslistsize = this.favouriteslistsize + favouritesList.length;
      this.listImpl.appendToFavoritesListView(favouritesList);
    }else{
      this.sortByDates(favouritesList);
    }
    
    AppEvents.multiSelectEvent.next({"dataArray":this.sortByDateArray});
    
  }

}